<template>
  <div class="bg" :style="{ background: 'url(' + bgUrl + ') no-repeat center / 100% 100%' }">
    <home-header></home-header>
    <div class="center">
      <div class="delayTime">请选择延长时间</div>
      <div class="selectTime">
        <div class="button">
          <span>15分钟</span>
        </div>
      </div>
      <div class="selectTimes">
        <div class="button">
          <span>30分钟</span>
        </div>
      </div>
      <div class="confirm">
        <div class="conButton" @click="ConfirmHandle">
          <span>确定</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from "./header";
import moment from "moment";
export default {
  components: {
    HomeHeader,
  },
  data() {
    return {
        bgUrl:''
    };
  },
  created() {},
  mounted(){
      this.bgUrl = localStorage.getItem('bgUrl')
  },
  methods: {
    ConfirmHandle() {
      this.$router.push({ path: "/delaySuccess" });
    },
  },
};
</script>

<style lang="less" scoped>
.bg {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .center {
    width: 70%;
    height: 70%;
    background: rgba(255, 255, 255, 0.1);
    margin: 6% auto;
    .delayTime {
      width: 100%;
      height: 35%;
      font-size: 48px;
      color: #ffffff;
      text-align: center;
      line-height: 250px;
      letter-spacing: 6px;
    }
    .selectTime {
      width: 12%;
      height: 20%;
      margin: 0 auto;
      .button {
        width: 160px;
        height: 56px;
        border-radius: 4px;
        background: linear-gradient(0deg, #1cf7e9, #2ad8ff);
        text-align: center;
        line-height: 55px;
      }
      span {
        font-size: 30px;
        color: #ffffff;
      }
    }
    .selectTimes {
      width: 12%;
      height: 20%;
      margin: 0 auto;
      .button {
        background: url(../assets/delay-rect.png) no-repeat;
        text-align: center;
        line-height: 66px;
      }
      span {
        font-size: 30px;
        color: #ffffff;
      }
    }
    .confirm {
      width: 7%;
      height: 15%;
      margin: 0 auto;
      .conButton {
        width: 100px;
        height: 100px;
        background: linear-gradient(0deg, #1cf7e9, #2ad8ff);
        text-align: center;
        border-radius: 50%;
        span {
          font-size: 36px;
          color: #ffffff;
          line-height: 92px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Delay.vue